import AppDispatcher from '../dispatcher/AppDispatcher';

export default {
    updateMovies: () => {
        AppDispatcher.dispatch({
            actionType: 'UPDATE_MOVIES'
        });
    }
}


/** WEBPACK FOOTER **
 ** ./src/actions/MovieActions.js
 **/